import axios from "axios";

const baseURL =
  // "http://localhost:5001/codewithvetriapi-c56e3/us-central1/myapp";
  "https://us-central1-codewithvetriapi-c56e3.cloudfunctions.net/myapp";

// Users API's

export const getAllUsers = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/users/getUsers`);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const validateLogin = async (token) => {
  try {
    const res = await axios.get(`${baseURL}/api/users/googleLogin`, {
      headers: { Authorization: "Bearer " + token },
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

// Concepts API's
// get all concepts
export const getAllConcepts = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/concepts/getAll`);
    return res.data;
  } catch (error) {
    return null;
  }
};

// get a concept
export const getAConceptByID = async (concept_id) => {
  try {
    const res = await axios.get(
      `${baseURL}/api/concepts/getConcept/${concept_id}`
    );
    return res.data;
  } catch (error) {
    return null;
  }
};

// add new concept
export const addNewConcept = async (data) => {
  try {
    const res = await axios.post(`${baseURL}/api/concepts/addNew`, { ...data });
    return res.data.data;
  } catch (error) {
    return null;
  }
};

// delete the concept
export const deleteConcept = async (conceptId) => {
  try {
    const res = await axios.delete(
      `${baseURL}/api/concepts/delete/${conceptId}`
    );
    return res.data;
  } catch (error) {
    return null;
  }
};

// Add new comment
export const addNewComment = async (concept_id, data) => {
  try {
    const res = await axios.post(
      `${baseURL}/api/concepts/addNewComment/${concept_id}`,
      { ...data }
    );
    return res.data.data;
  } catch (error) {
    return null;
  }
};

// delete a comment
export const deleteMyComment = async (ids) => {
  try {
    const res = await axios.delete(`${baseURL}/api/concepts/deleteComment/`, {
      params: { ...ids },
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

// adding as a favourite
export const addAsFavourite = async (user_id, data) => {
  try {
    const res = await axios.post(
      `${baseURL}/api/concepts/addFavourite`,
      { ...data },
      { params: { user_id: user_id, concept_id: data.concept_id } }
    );
    return res.data.data;
  } catch (error) {
    return null;
  }
};

// get all favourites by id
export const getAllFavourites = async (user_id) => {
  try {
    const res = await axios.get(
      `${baseURL}/api/concepts/getFavourite/${user_id}`
    );
    return res.data;
  } catch (error) {
    return null;
  }
};

// delete my favourite
export const deleteMyFavourite = async (ids) => {
  console.log(ids);
  try {
    const res = await axios.delete(`${baseURL}/api/concepts/deleteFavourite/`, {
      params: { ...ids },
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

// Trainers API
// add new trainer
export const addNewTrainer = async (data) => {
  try {
    const res = await axios.post(`${baseURL}/api/trainers/addNew`, { ...data });
    return res.data.data;
  } catch (error) {
    return null;
  }
};

// get all trainers
export const getAllTrainers = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/trainers/getAll`);
    return res.data;
  } catch (error) {
    return null;
  }
};
